import { z } from 'zod';

const optionalText = (max, label) => z
  .string()
  .max(max, `${label}最多 ${max} 字`)
  .optional()
  .or(z.literal(''));

const addressRowSchema = z.object({
  addressType: optionalText(50, '地址類型'),
  postalCode: optionalText(20, '郵遞區號'),
  address: z.string().trim().min(1, '地址不能為空'),
  isDefault: z.boolean().optional(),
  remark: optionalText(500, '備註'),
});

const contactRowSchema = z.object({
  name: z.string().trim().min(1, '聯絡人姓名不能為空').max(100, '姓名最多 100 字'),
  department: optionalText(100, '部門'),
  title: optionalText(100, '職稱'),
  phone: optionalText(100, '電話'),
  mobile: optionalText(100, '手機'),
  email: optionalText(200, 'Email'),
  isDefault: z.boolean().optional(),
  remark: optionalText(500, '備註'),
});

export const supplierFormSchema = z.object({
  code: z.string().trim().min(1, '代號不能為空').max(50, '代號最多 50 字'),
  name: z.string().trim().min(1, '名稱不能為空').max(200, '名稱最多 200 字'),
  chineseName: optionalText(200, '中文名'),
  englishName: optionalText(200, '英文名'),
  taxIdNumber: optionalText(50, '統編'),
  homepage: optionalText(300, '網址'),
  phone: optionalText(100, '電話'),
  fax: optionalText(100, '傳真'),
  remark: z.string().optional().or(z.literal('')),
  addresses: z.array(addressRowSchema),
  contacts: z.array(contactRowSchema),
});

export const SUPPLIER_FORM_DEFAULT_VALUES = {
  code: '',
  name: '',
  chineseName: '',
  englishName: '',
  taxIdNumber: '',
  homepage: '',
  phone: '',
  fax: '',
  remark: '',
  addresses: [],
  contacts: [],
};
